<template>
  <div id="info-window">
    <img src="/static/img/home/close.png" class="close-info" @click="handleClose">
    <h2>设备情况</h2>
    <div class="info-content">
      <h6><img src="/static/img/home/arrow.png" alt="">基本信息</h6>
      <div class="base-info">
        <p class="p1">
          <span
            class="base-item"
            :title="basedata.guid"
          >GUID：<span>{{ basedata.guid }}</span></span>
          <span
            class="base-item"
            :title="basedata.code"
          >编号：<span>{{ basedata.code }}</span></span>
          <span
            class="base-item"
            :title="basedata.name4Company"
          >名称：<span>{{ basedata.name4Company }}</span></span>
          <span
            class="base-item"
            :title="basedata.warnings"
          >告警：<span class="alerm">{{ basedata.warnings }}(次)</span></span>
        </p>
        <p>
          <span
            class="base-item"
            style="width: 298px"
            :title="basedata.installPosition"
          >位置：<span>{{ basedata.installPosition }}</span></span>
          <!-- <span class='base-item'>采样频率：<span>{{basedata.speed}}</span></span> -->
          <span
            class="base-item"
          >设备状态：<span>{{ basedata.online ? '正常' : '离线' }}</span></span>
          <span
            class="base-item"
            style="width: 162px"
            :title="basedata.position"
          >坐标：<span>{{ basedata.position }}</span></span>
        </p>
        <p>
          <span
            class="base-item"
          >电池电压：<span>{{ baseDataByKey('batteryVol') }}</span></span>
          <!-- basedata.groupId === 2 为瞭望者 -->
          <span
            v-if="basedata.groupId === 2"
            class="base-item"
          >太阳能电压：<span>{{ baseDataByKey('solarVol') }}</span></span>
          <span
            v-if="basedata.groupId === 2"
            class="base-item"
          >负载开关：<span>{{
            baseDataByKey('swState') === true ? '开' : baseDataByKey('swState')
          }}</span></span>
        </p>
      </div>
    </div>
    <div class="info-data">
      <h6 v-if="basedata.groupId === 1">
        <img src="/static/img/home/arrow.png" alt="">历史数据
      </h6>
      <h6 v-if="basedata.groupId === 2">
        <img src="/static/img/home/arrow.png" alt="">实时数据
      </h6>
      <div
        ref="chart_line"
        v-loading="loading"
        class="info-chart"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0)"
      ></div>
      <div v-if="!basedata.online" class="info-chart info-chart-nodata">
        设备离线中
      </div>
      <!-- <div class='info-chart' ref='chart_distence'></div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoWindow',
  components: {},
  props: {
    basedata: {
      type: Object,
      default () {
        return {
          deviceId: '--',
          deviceName: '--',
          deviceType: '--',
          address: '--',
          position: '--',
          speed: '--',
          deviceStatic: '--',
          alarmTimes: '--',
        }
      },
    },
  },
  data () {
    return {
      chart_line: null, // 加速度chart对象
      chart_distence: null, // 位移chart对象
      timmer_line: null, // 加速度timmer
      timmer_distence: null, // 位移timmer
      loading: true, // 加载实时数据 和历史数据 loading
    }
  },
  created () {},
  mounted () {
    this.initChart()
  },
  methods: {
    baseDataByKey (key) {
      return this.basedata[key] ? this.basedata[key] : '--'
    },
    initChart () {
      // 加速度
      let chartDom = this.$refs.chart_line
      this.chart_line = this.$echarts.init(chartDom)
    },
    handleClose () {
      this.$emit('handleClose')
    },

    setChartOption (option) {
      this.chart_line.setOption(option)
      this.loading = false
    },
  },
}
</script>

<style lang="less" scoped>
#info-window {
  color: #fff;
  // width: 887px;
  // height: 592px;
  width: 690px;
  height: 490px;
  position: relative;
  z-index: 99;
  background: url('/static/img/home/dialogBackgroundDefault.png') no-repeat;
  background-size: cover;

  .close-info {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 20px;
    top: 13px;
  }

  h2 {
    width: 390px;
    height: 40px;
    line-height: 31px;
    background: url('/static/img/home/dialogHeaderSmall.png') no-repeat;
    background-size: contain;
    position: relative;
    top: -15px;
    margin: 0 auto;
    color: #fff;
    text-align: center;
    font-size: 18px;
  }

  .info-content {
    border: 1px solid #15477c;
    width: 90%;
    // height: 95px;
    margin: 10px auto;
    padding: 10px;
    .base-info {
      font-size: 14px;
      color: #3fc3ff;
      p {
        margin-top: 20px;
        // margin-left: 15px;
        .base-item {
          display: inline-block;
          width: 150px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          span {
            color: #4dd292;
          }
        }
        span.alerm {
          color: red;
          font-weight: bold;
        }
      }
    }
  }
  .info-data {
    border: 1px solid #15477c;
    padding: 10px;
    width: 90%;
    margin: 15px auto;
    position: relative;
    // .info-chart{
    //   display: inline-block;
    //   width: 298px;
    //   height: 200px;
    //   background-color: rgba(25,48,138,.4);
    //   margin-left: 10px;
    // }
    .info-chart {
      // display: inline-block;
      width: 600px;
      height: 200px;
      background-color: rgba(25, 48, 138, 0.4);
      margin-left: 10px;
    }
    .info-chart-nodata {
      position: absolute;
      text-align: center;
      background-color: rgba(25, 48, 138, 1);
      line-height: 100px;
      top: 34px;
    }
  }
  h6 {
    margin-bottom: 10px;
    img {
      padding-right: 10px;
    }
  }
}
</style>
